import React from "react";

type GitPromptProps = {
  command?: string;
  path?: string;
  branch?: string;
  className?: string;
};

const GitPrompt = ({
  command = "git status",
  path = "~/diti.space",
  branch = "main",
  className = "",
}: GitPromptProps) => {
  return (
    <div
      className={`terminal-line text-xs sm:text-sm text-slate-400 break-words ${className}`}
    >
      <span className="text-emerald-400">{path}</span>
      <span className="mx-1 sm:mx-2">on</span>
      <span className="text-cyan-400">{branch}</span>
      <span className="text-amber-400 ml-1">*</span>
      <span className="mx-1 sm:mx-2 text-slate-500">›</span>
      <span className="text-slate-400 break-all sm:break-normal">{command}</span>
      <span className="terminal-cursor" />
    </div>
  );
};

export default GitPrompt;
